import styled from 'styled-components';

export const Container = styled.div`
  background-color: var(--color-card-background-100);
  color: var(--color-text-quote-100);
  max-width: 100%;
  padding: 20px;
  position: relative;
  width: 100%;

  @media (min-width: ${props => props.theme.breakpoints.minWidth.XS}) {
    max-width: 270px;
  }

  > * + * {
    padding-top: 12px;
  }
  > * + *:last-of-type {
    padding-top: 20px;
  }

  &.rounded {
    border-radius: ${({ theme }) => theme.borders.cardRadius};
  }
`;

export const LinkContainer = styled.div`
  display: flex;

  :nth-child(2) {
    margin-top: 20px;
  }

  a {
    color: ${({ theme }) => theme.colors.secondary()};
  }
  a.text-primary {
    color: ${({ theme }) => theme.colors.primary()};
  }

  svg {
    margin-right: 12px;
    max-width: 20px;
    width: 100%;
  }

  g {
    fill: ${({ theme }) => theme.colors.secondary()};
  }
`;
